<template>
  <div>
    {{ title }}
    <!-- control for entity advancement -->
    <div
      class="content-searcher-erp"
      :class="{ 'disabled-component': disabled }"
    >
      <div class="content-searcher-erp__input">
        <form
          class="content-search-input"
          @submit.prevent="ValidateSearch"
        >
          <input
            type="text"
            class="input-search"
            :placeholder="placeholder"
            :value="searchFieldValue"
            :disabled="disableInput"
            @input="
              searchFieldValue = $event.target.value;
              SearchBarValueChanged();
            "
            @keyup.enter="SearchMode"
          >

          <div
            class="input-search-icon"
            @click="ClickInputButton()"
          >
            <img
              v-show="componentMode === states.INITIAL"
              class="selectable input-search-icon__search"
              src="@/static/icons/ic_shape.svg"
              width="20px"
              height="20px"
            >
            <img
              v-show="componentMode === states.SEARCH"
              class="selectable input-search-icon__cancel"
              src="@/static/icons/ic_cancel.svg"
              width="12px"
              height="12px"
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';

// import { Log, LogError } from '@/js/common/HIDebuggingSupport';

export default {
  name: 'UCSearch',
  props: {
    title: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    minLength: { type: Number, default: 0 },
    findOnChange: { type: Boolean, default: false },

  },

  emits: [
    'change',
    'search-bar-value-changed',
  ],

  data() {
    return {
      states: {
        INITIAL: 'INITIAL',
        SEARCH: 'SEARCH',
      },
      componentMode: '', // states del componente = states.
      searchFieldValue: '', // Valor que contiene el input
      disableInput: false, // Controla que no se permita cambiar el valor del input.
    };
  },
  watch: {
    disabled(val) {
      this.disableInput = val;
    },
  },
  mounted() {
    this.componentMode = this.states.INITIAL;
  },
  methods: {
    Clear() {
      this.searchFieldValue = '';
      this.disableInput = false;
      this.InitialMode();
    },
    RemoveFocusActiveElement() {
      const elementoActivo = document.activeElement;
      elementoActivo.blur();
    },
    ValidateSearch() {
      this.RemoveFocusActiveElement();
      this.SearchMode();
    },

    InitialMode() {
      this.componentMode = this.states.INITIAL;
      this.$emit('change', '');
    },

    ClickInputButton() {
      if (this.componentMode === this.states.INITIAL) {
        this.SearchMode();
      } else if (this.componentMode === this.states.SEARCH) {
        this.Clear();
      }
    },

    SearchMode() {
      if (this.searchFieldValue.length < this.minLength) {
        // this.$refs.inputSearch.setCustomValidity('Indica al menos tres digitos para buscar');
        HiNotification.Toast(this.$t('search.minLength', { number: this.minLength }));
        // this.$refs.inputSearch.errorMessageForce = true;
        return;
      }
      this.componentMode = this.states.SEARCH;
      this.disableInput = false;
      this.$emit('change', this.searchFieldValue);
    },
    SearchBarValueChanged() {
      this.$emit('search-bar-value-changed', this.searchFieldValue);
      if (this.componentMode === this.states.SEARCH) {
        this.componentMode = this.states.INITIAL;
      }
      if (this.findOnChange) {
        this.componentMode = this.states.SEARCH;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content-searcher-erp {
  display: flex;
  align-items: center;

  &__input {
    width: 100%;
  }

  &__arrow-btn {
    background-color: var(--his-steel-blue);
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 3px;
  }

  .content-search-input {
    display: flex;
    flex-direction: row;
    background-color: var(--search-input-bg-color);
    border-radius: var(--search-input-border-radius);
    border: var(--search-input-border);
    box-sizing: border-box;

    input {
      height: var(--search-input-height);
      color: var(--search-input-color);
      font-size: var(--search-input-font-size);
      padding: var(--search-input-padding);
    }

    .input-search {
      width: calc(100% - 30px);
    }

    .input-search-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      box-sizing: border-box;
      min-width: var(--search-btn-min-width);
      border-left: var(--search-btn-border-left);
      background: var(--search-btn-bg-color);
      border-top-right-radius: 7px;
      border-bottom-right-radius: 7px;

      &__search {
        width: var(--search-btn-search-img-size);
        height: var(--search-btn-search-img-size);
      }

      &__cancel {
        width: var(--search-btn-cancel-img-size);
        height: var(--search-btn-cancel-img-size);
      }
    }
  }
}

.disabled-component {
  opacity: 0.6;
  pointer-events: none;
}
</style>
